"use client";

import { useEffect, useState } from "react";
import dynamic from "next/dynamic";

// Keeps the react-instantsearch + Chat bundle (~190KB) off the initial
// hydration path. The floating toggle button mounts once the browser is idle.
const AgentChat = dynamic(
  () => import("./agent-chat.component").then((mod) => mod.AgentChat),
  { ssr: false, loading: () => null },
);

interface AgentChatDeferredProps {
  agentId?: string;
}

export function AgentChatDeferred({ agentId }: AgentChatDeferredProps) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (typeof window.requestIdleCallback === "function") {
      const id = window.requestIdleCallback(() => setReady(true));
      return () => window.cancelIdleCallback(id);
    }
    const id = window.setTimeout(() => setReady(true), 1500);
    return () => window.clearTimeout(id);
  }, []);

  if (!ready) return null;
  return <AgentChat agentId={agentId} />;
}
